import { SPEAKER_TONE_COUNT } from 'components/CallScribe/callScribeTheme';
import { findParticipant, normaliseSpeaker } from 'services/callScribe/participants';
import { CallScribeSpeaker, ICallScribeParticipant } from 'services/callScribe/types';

export const speakerSlots = (
  participants: ICallScribeParticipant[] | undefined,
): Map<number, number> => {
  const ordered = [...(participants ?? [])].sort((a, b) => a.id - b.id);
  return new Map(ordered.map((p, i) => [p.id, i % SPEAKER_TONE_COUNT]));
};

const roleSlot = (speaker: unknown): number =>
  normaliseSpeaker(speaker) === CallScribeSpeaker.Customer ? 1 : 0;

export const slotForPerson = (p: ICallScribeParticipant, slots: Map<number, number>): number =>
  slots.get(p.id) ?? roleSlot(p.role);

export const slotForLine = (
  line: { participantId?: number | null; speaker: CallScribeSpeaker },
  participants: ICallScribeParticipant[] | undefined,
  slots: Map<number, number>,
): number => {
  const who = findParticipant(line, participants);
  return who ? slotForPerson(who, slots) : roleSlot(line.speaker);
};
